module.exports = __webpack_public_path__ + "img/banner_title.57f3266.png";